import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuCli = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	height: "1em",
	viewBox: "0 0 18 15",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M9.8 10.6H13.8M4.2 4.2L7.4 7.4L4.2 10.6M1 12.2V2.6C1 2.17565 1.16857 1.76869 1.46863 1.46863C1.76869 1.16857 2.17565 1 2.6 1H15.4C15.8243 1 16.2313 1.16857 16.5314 1.46863C16.8314 1.76869 17 2.17565 17 2.6V12.2C17 12.6243 16.8314 13.0313 16.5314 13.3314C16.2313 13.6314 15.8243 13.8 15.4 13.8H2.6C2.17565 13.8 1.76869 13.6314 1.46863 13.3314C1.16857 13.0313 1 12.6243 1 12.2Z",
	stroke: "#434343",
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgMainMenuCli);
export default ForwardRef;
